import React from 'react';

const Skeleton = () => {
  return (
    <div className="overview-block store-overview">
      <div className="stats-wrapper">
        {
          [1,2,3,4,5].map((el) => (
            <div className={'store-overview-stat-wrapper'}
                 key={el}
            >
              <div className={'title'}>
                <span className={'link-skeleton'} style={{ width: 96, height: 20 }} />
              </div>
              <div className={'value'}>
                <span className={'link-skeleton'} style={{ width: 70, height: 20 }} />
              </div>
            </div>
          ))
        }
            <div className={'store-overview-stat-wrapper channels-wrapper'}>
              <div className={'title'}>
                <span className={'link-skeleton'} style={{ width: 96, height: 20 }} />
              </div>
              <div className={'value'}>
                {
                  [1,2,3].map(el => (
                    <span key={el} className={'link-skeleton'} style={{ width: 20, height: 20 }} />
                  ))
                }
              </div>
            </div>
      </div>
    </div>
  );
};

export default Skeleton;
